import { NewsArticleResultItem } from "../types";

import { Card, Heading, Link, Paragraph } from "@digdir/designsystemet-react";

const NewsArticleCard = (props: NewsArticleResultItem) => {
  const { linkUrl, heading, mainIntro, date } = props;

  return (
    <Card>
      <Card.Block>
        <Paragraph>{date}</Paragraph>
        <Heading level={2}>
          <Link href={linkUrl} rel="noopener noreferrer">
            {heading}
          </Link>
        </Heading>
        {mainIntro && <Paragraph>{mainIntro}</Paragraph>}
      </Card.Block>
    </Card>
  );
};

export default NewsArticleCard;
